import { authApi } from "./authApi";
import { customerApi } from "./customerApi";
import { inventoryApi } from "./inventoryApi";
import { settingsApi } from "./settingsApi";

import type { Middleware } from "@reduxjs/toolkit";
import type { ReducersMapObject } from "@reduxjs/toolkit";
import { inquiryApi } from "./inquiryApi";
import { bookingApi } from "./bookingApi";
import { discountApi } from "./discountApi";

// Typed reducers object
export const apiReducers: ReducersMapObject = {
  [inquiryApi.reducerPath]: inquiryApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [customerApi.reducerPath]: customerApi.reducer,
  [inventoryApi.reducerPath]: inventoryApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  [bookingApi.reducerPath]: bookingApi.reducer,
  [discountApi.reducerPath]: discountApi.reducer,
};

// Typed middleware array
export const apiMiddleware: Middleware[] = [
  inquiryApi.middleware,
  authApi.middleware,
  customerApi.middleware,
  inventoryApi.middleware,
  settingsApi.middleware,
  bookingApi.middleware,
  discountApi.middleware,
];
